import useAlbumId from '@/hooks/useAlbumId';
import useGetProjectQuery from '@/hooks/useGetProjectQuery';
import { projectServicePrsPrefix } from '@/utils/helper';
import { useMemo } from 'react';

/**
 * Hook to retrieve the Release to which the current album belongs.
 * - Releases are created via the Project Service by grouping together related products.
 */
export default function useRelease() {
  const { data: project } = useGetProjectQuery();
  const albumId = useAlbumId();

  return useMemo(() => {
    return project?.releases?.find((release) =>
      release.content.find(
        (content) => content.urn === `${projectServicePrsPrefix}${albumId}`
      )
    );
  }, [project, albumId]);
}
